import React from 'react'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DynamicPriceIcon } from '@e3dc-react/icons'

interface Props {
  isDynamicPowerPriceEnabled: boolean
  isCharging: boolean
  isPriceBelowLimit: boolean
}

/**
 * This component provides the dynamic power price and icon if it's active
 */
export const DynamicPriceIconOnWallboxCards: React.FC<Props> = ({ isDynamicPowerPriceEnabled, isPriceBelowLimit, isCharging }) => {
  const { t } = useCustomTranslation()
  const tooltipActiveDPP = t('systemSettings.dynamic-prices.wallbox-card.activated')
  const tooltipInactiveDPP = t('systemSettings.dynamic-prices.wallbox-card.deactivated')
  const tooltipUndefinedDPP = t('systemSettings.dynamic-prices.wallbox-card.undefined')
  const tooltipDPPForWallboxCharging = t('systemSettings.dynamic-prices.wallbox-card.charging')
  const getTitle = (): string => {
    if (!isDynamicPowerPriceEnabled) return tooltipInactiveDPP

    if (!isPriceBelowLimit && !isCharging) return tooltipInactiveDPP
    if (!isPriceBelowLimit && isCharging) return tooltipDPPForWallboxCharging

    if (isPriceBelowLimit && !isCharging) return ''
    if (isPriceBelowLimit && isCharging) return tooltipActiveDPP

    return tooltipUndefinedDPP
  }

  return (
    <OptionalTooltipWrapper titleKey={getTitle()} placement={'bottom'}>
      <DynamicPriceIcon
        sx={{ ml: 1, width: '16px', height: '16px' }}
        color="secondary"
        opacity={isDynamicPowerPriceEnabled && isPriceBelowLimit ? '100%' : '25%'}
      />
    </OptionalTooltipWrapper>
  )
}
